// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors"; // Starter Custom Code
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import User from "@insite/mobius/Icons/User";
import Menu, { MappedLink } from "@insite/mobius/Menu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { Suspense, lazy, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

// Starter Custom Code - >
import { getCookie } from "@insite/client-framework/Common/Cookies";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import { StyledClickable } from "@insite/mobius/Link";
// import Popover, { PopoverPresentationProps } from "@insite/mobius/Popover/Popover";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import SideMenu, { SideMenuLinkPresentationProps } from "@store/Library/Components/Toolkit/SideMenu";
import { SideMenuStyles } from "@store/Library/Components/Toolkit/SideMenu";
import { NavigationModeCookieName } from "@store/Overrides/Components/NavigationModeMenu";
import constants from "@store/constants"; // Store Custom Code
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks"; // Store Custom Code
import ChevronDown from "@store/Library/Components/Icons/ChevronDown"; // Store Custom Code
import PersonFill from "@store/Library/Components/Icons/Person/PersonFill"; // Store Custom Code
import { linkStyles } from "@store/Themes/common/mixins/link"; // Store Custom Code
import { ellipsis } from "@store/Themes/common/mixins/ellipsis"; // Store Custom Code
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Starter Custom Code

/* Store Custom Code - Start */
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@store/Overrides/Components/AddressInfoDisplay";
import { addressProps } from "@store/Themes/common/props/address";
import StoreUser from "@store/Library/Components/Icons/StoreUser";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { ChangeEvent, useState } from "react";
import Popover, { PopoverPresentationProps } from "@store/MobiusOverrides/Popover/Popover";
import setFulfillmentMethod from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import updatePickUpWarehouse from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import useChangeCustomerWithRedirect from "@store/Framework/Common/Hooks/useChangeCustomerAndRedirect";
import useGetShipToAndBillTo from "@store/Framework/Store/Data/Accounts/Hooks/useGetShipToAndBillTo";
const FindLocationModal = lazy(
    () => import(/* webpackChunkName: "findLocationModal" */ "@store/Overrides/Components/FindLocationModal"),
);
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import HeaderLink, { HeaderLinkStyles } from "@store/Library/Components/Toolkit/HeaderLink";
/* Store Custom Code - End */

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    includeAccountMenu = "includeAccountMenu",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

const mapStateToProps = (state: ApplicationState) => {
    /* Starter Custom Code - Start */
    const { firstName, lastName, userName } = state.context.session;
    const settings = getSettingsCollection(state);
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    /* Starter Custom Code - End */

    return {
        isSignInPage: getCurrentPage(state).type === "SignInPage",
        userName, // Starter Custom Code
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentUserIsGuest, // Starter Custom Code
        isPunchOutSession: getIsPunchOutSession(state),
        currentLocation: getLocation(state),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
        showInventory: state.context.showInventory,
        showPricing: state.context.showPricing,
        isReorderConfirmationModalOpen: state.pages.vmiBins.isReorderConfirmationModalOpen,
        hasChangeLastQty:
            state.pages.vmiBins.selectVmiBinsChangedQty &&
            Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0,
        orderConfirmationPageUrl: getPageLinkByPageType(state, "OrderConfirmationPage")?.url,
        onePageCheckoutConfirmationPageUrl: getPageLinkByPageType(state, "OnePageCheckoutConfirmationPage")?.url,
        // Starter Custom Code
        isSignedIn: userName && !currentUserIsGuest,
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        currentBillTo: getCurrentBillToState(state).value,
        currentShipTo: getCurrentShipToState(state).value,
        enableWarehousePickup: settings.accountSettings.enableWarehousePickup,
        fulfillmentMethod: state.context.session.fulfillmentMethod,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    // Starter Custom Code
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
    // Store Custom Code
    setFulfillmentMethod,
    updatePickUpWarehouse,
};

export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    // Starter Custom Code
    headerLink?: HeaderLinkStyles;
    popover?: PopoverPresentationProps;
    sideMenu?: SideMenuStyles;
    arrowIcon?: IconPresentationProps;
    // Store Custom Code
    headerAccountWrapper?: InjectableCss;
    headerAccountLabel?: TypographyPresentationProps;
    headerAccountNameWrapper?: InjectableCss;
    popoverGridContainer?: GridContainerProps;
    popoverMenuGridItem?: GridItemProps;
    popoverInfoGridItem?: GridItemProps;
    loadingOverlay?: LoadingOverlayProps;
    infoSection?: InjectableCss;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoSubtitle?: TypographyPresentationProps;
    addressWrapper?: InjectableCss;
    addressName?: TypographyPresentationProps;
    address?: AddressInfoDisplayStyles;
    addressLink?: LinkPresentationProps;
    fulfillmentRadioGroup?: RadioGroupProps;
    // Starter Code Removed - accountMessagesCountStyles
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: css`
            ${breakpointValues(["none", null, "inline-flex"], "display")}
        `,
    },
    titleClickable: {
        css: css`
            display: flex;
            align-items: center;

            ${linkStyles("text.darkest", "primary", false, false)}; /* Store Custom Code */
        `,
    },
    titleIcon: {
        color: "inherit", // Store Custom Code
        size: 28,
    },
    titleTypography: {
        css: css`
            ${ellipsis(pxToRem(100))} // Bunzl custom code
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
        `,
    },
    signOutClickable: {
        css: css`
            flex: 0 0 auto;
        `,
    },
    popover: {
        wrapperProps: {
            css: css`
                ${breakpoint("sm", "down")} {
                    position: static;
                }
            `,
        },
        contentBodyProps: {
            css: css`
                width: ${pxToRem(700)};
                max-height: none;
                color: ${getColor("text")};

                ${breakpoint("sm", "down")} {
                    max-width: 100%;
                }
            `,
        },
    },
    arrowIcon: {
        size: 28,
        color: "inherit", // Store Custom Code
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            width: ${pxToRem(15)};
                            height: ${pxToRem(15)};
                        `,
                        null,
                        null,
                        css`
                            width: ${pxToRem(28)};
                            height: ${pxToRem(28)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    /* Store Custom Code - Start */
    sideMenu: {
        wrapper: {
            css: css`
                width: 100%;
                padding: ${pxToRem(10, 15)};
            `,
        },
        link: {
            css: css`
                background: none;
                border: none;
                font-size: ${({ theme }) => theme.design.typography.size.smaller};
                padding-left: 0;
                padding-right: 0;
                ${linkStyles("text", "primary", false, true)};
            `,
            icon: {
                position: "right",
                iconProps: {
                    src: ChevronRight,
                    color: "inherit", // Store Custom Code
                    size: 18,
                    css: css`
                        margin-left: auto;
                    `,
                },
            },
        },
        signOutLink: {
            css: css`
                ${({ theme }) => theme.button?.secondary?.css}
                background-color: ${getColor("secondary")};
                color: ${getColor("secondary.contrast")};
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
                border: 0;
                border-radius: ${pxToRem(6)};
                font-size: ${({ theme }) => theme.design.typography.size.small};

                &:hover {
                    background-color: ${getColor("secondary.dark")};
                    text-decoration: none;
                }
            `,
        },
    },
    headerAccountWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-left: ${pxToRem(8)};
        `,
    },
    headerAccountLabel: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smallest};
            line-height: ${({ theme }) => theme.design.typography.lineHeight.smaller};
            color: ${getColor("text.accent")};
        `,
    },
    headerAccountNameWrapper: {
        css: css`
            display: flex;
            align-items: center;
            // bunzl custom code
            :hover {
                color: ${getColor("primary.main")};
            }
        `,
    },
    popoverGridContainer: { gap: 0 },
    popoverInfoGridItem: {
        width: [12, 8, 8, 8, 8],
        css: css`
            padding: ${pxToRem(20)};
            flex-direction: column;
            order: 2;
            font-size: ${x => x.theme.design.typography.size.smaller};
            background-color: ${getColor("secondary.light")};

            ${breakpoint("sm")} {
                order: 1;
            }
        `,
    },
    popoverMenuGridItem: {
        width: [12, 4, 4, 4, 4],

        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            order: 1;
            /* bunzl custom code, allow for scrolling with too many menu items */
            max-height: 85vh;
            overflow-y: auto;

            ${breakpoint("sm")} {
                order: 2;
                border-bottom: 0;
                border-left: 1px solid ${getColor("common.border")};
            }
        `,
    },
    infoGridContainer: {
        gap: 0,
        css: css`
            ${x => gridGapStyles(pxToRemArray([20]), [x.theme.design.typography.spacing.base])}
        `,
    },
    infoGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    loadingOverlay: {
        css: css`
            height: 100%;
        `,
    },
    infoSection: {
        css: css`
            width: 100%;
            padding-bottom: ${pxToRem(16)};
            margin-bottom: ${pxToRem(16)};
            border-bottom: 1px solid ${getColor("common.border")};

            &:last-child {
                padding-bottom: 0;
                margin-bottom: 0;
                border-bottom: 0;
            }
        `,
    },
    infoSubtitle: addressProps.label,
    addressName: addressProps.name,
    addressLink: addressProps.link,
    fulfillmentRadioGroup: {
        sizeVariant: "small",
    },
    /* Store Custom Code - End */
    // Starter Removed Code - accountMessagesCountStyles
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderSignIn = ({
    userName,
    isSignInPage,
    currentUserIsGuest,
    signOut,
    cancelPunchOut,
    fields,
    history,
    myAccountPageLink,
    signInUrl,
    isPunchOutSession,
    currentLocation,
    displayChangeCustomerLink,
    displayPricingAndInventory,
    showInventory,
    showPricing,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    theme,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    orderConfirmationPageUrl,
    onePageCheckoutConfirmationPageUrl,
    // Starter Custom Code
    userDisplayName,
    currentBillTo,
    currentShipTo,
    fulfillmentMethod,
    pickUpWarehouse,
    enableWarehousePickup,
    isAuthenticated,
    isSignedIn,
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
    setFulfillmentMethod,
    updatePickUpWarehouse,
}: Props) => {
    const styles: HeaderSignInStyles = useMergeStyles("headerSignIn", headerSignInStyles);

    // Starter Custom Code
    const displayName = useDisplayName();
    const element = React.useRef<HTMLUListElement>(null);
    const popover = React.useRef<React.ComponentRef<typeof Popover>>(null);
    useEffect(() => {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }, [userName]);

    /* Store Custom Code - Start */
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const [isLocationModalLoading, setIsLocationModalLoading] = useState(false);
    const [isInfoLoading, setIsInfoLoading] = useState(false);

    const { billTo, shipTo } = useGetShipToAndBillTo();
    const { navigateToChangeCustomerPageWithRedirect } = useChangeCustomerWithRedirect();
    const handleNavigateToChangeCustomerPage = () => {
        navigateToChangeCustomerPageWithRedirect();
        closePopover();
    };

    useEffect(() => {
        if (isAuthenticated && isSignedIn) {
            if (!currentBillTo) {
                loadCurrentBillTo();
            }
            if (!currentShipTo) {
                loadCurrentShipTo();
            }
        }
    }, [currentBillTo, currentShipTo, isAuthenticated, isSignedIn, loadCurrentBillTo, loadCurrentShipTo]);
    /* Store Custom Code - End */

    if (!myAccountPageLink) {
        return null;
    }
    /* Store Custom Code - moved up to pass close popover - Start */
    const closePopover = () => {
        popover.current?.closePopover();
    };
    /* Store Custom Code - moved up to pass close popover - End */

    const { visibilityState, includeAccountMenu, showInventoryToggle, showPricingToggle } = fields;
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";
    // Starter Custom Code

    if (fields.icon === "User") {
        icon = StoreUser; // Store Custom Code
    }

    const currentMode = getCookie(NavigationModeCookieName);
    let menuItems = (myAccountPageLink?.children?.filter(
        pageLink => !(pageLink.type === "ChangeCustomerPage" && !displayChangeCustomerLink),
    ) ?? []) as MappedLink[];

    const getMenuItem = (title: "Inventory" | "Pricing"): MappedLink => {
        return {
            title: title === "Inventory" ? translate("Inventory") : translate("Pricing"),
            iconProps: {
                src: (title === "Inventory" && showInventory) || (title === "Pricing" && showPricing) ? EyeOff : Eye,
                size: 22,
                css: css`
                    margin-left: 20px;
                    margin-right: -12px;
                `,
            },
            clickableProps: {
                css: css`
                    display: flex;
                    text-transform: uppercase;
                `,
                onClick: () => {
                    title === "Inventory"
                        ? setShowInventory({ showInventory: !showInventory })
                        : setShowPricing({ showPricing: !showPricing });
                },
            },
        };
    };

    if (!currentMode || currentMode === "Storefront") {
        menuItems = menuItems?.filter(pageLink => pageLink.type !== "VmiUsersPage");

        // Starter Removed - showInventoryToggle
        // Starter Removed - showPricingToggle
    }

    const onSignInHandler = (e: React.MouseEvent) => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            e.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
                return;
            }

            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
                return;
            }

            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (
                returnUrl === "/" ||
                (currentUserIsGuest && orderConfirmationPageUrl && returnUrl.indexOf(orderConfirmationPageUrl) > -1) ||
                (currentUserIsGuest &&
                    onePageCheckoutConfirmationPageUrl &&
                    returnUrl.indexOf(onePageCheckoutConfirmationPageUrl) > -1)
            ) {
                history.push(`${signInUrl}`);
                return;
            }

            history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
        }
    };

    const onSignOutHandler = () => {
        if (!isReorderConfirmationModalOpen && hasChangeLastQty) {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: signOutFunc });
        } else {
            signOutFunc();
        }
    };

    const signOutFunc = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    let signInStatusText = translate("Sign In");
    if (userName && !currentUserIsGuest) {
        signInStatusText = userDisplayName; // Starter Custom Code
    }

    /* Store Custom Code - Start */
    const handleChangeFulfillmentMethod = (event: ChangeEvent<HTMLInputElement>) => {
        setIsInfoLoading(true);
        setFulfillmentMethod({
            fulfillmentMethod: event.currentTarget.value as "Ship" | "PickUp",
            onComplete: () => {
                setIsInfoLoading(false);
            },
        });
    };

    const changeWarehouse = () => {
        setIsLocationModalOpen(true);
    };

    const selectWarehouse = (pickUpWarehouse: WarehouseModel) => {
        closeLocationModal();
        updatePickUpWarehouse({
            pickUpWarehouse,
        });
    };

    const closeLocationModal = () => setIsLocationModalOpen(false);
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.signOutWrapper}>
            {includeAccountMenu && userName && !currentUserIsGuest && (
                /* Starter Custom Code */
                <>
                    <Popover
                        {...styles.popover}
                        controlsId="accountMenu"
                        data-test-selector="header_accountMenu"
                        contentBodyProps={{
                            ...styles.popover?.contentBodyProps,
                            as: "div",
                            ref: element,
                        }}
                        positionFunction={() => {
                            return {
                                position: "absolute",
                                right: 0,
                            };
                        }}
                        ref={popover}
                        insideRefs={[element]}
                        popoverTrigger={
                            <Clickable {...styles.titleClickable} data-test-selector="header_signIn">
                                {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                                {showLabel && (
                                    // A11Y - span for accessibility
                                    <Hidden below="lg" as="span">
                                        {/* Store Custom Code - Start */}
                                        <StyledWrapper {...styles.headerAccountWrapper}>
                                            <Typography {...styles.headerAccountLabel}>
                                                {translate("My Account")}
                                            </Typography>
                                            <StyledWrapper {...styles.headerAccountNameWrapper}>
                                                <Typography
                                                    {...styles.titleTypography}
                                                    data-test-selector="header_userName"
                                                    title={displayName}
                                                >
                                                    {displayName}
                                                </Typography>
                                                <Icon {...styles.arrowIcon} src={ChevronDown} />
                                            </StyledWrapper>
                                        </StyledWrapper>
                                        {/* Store Custom Code - End */}
                                    </Hidden>
                                )}
                            </Clickable>
                        }
                    >
                        {/* Store Custom Code - Start */}
                        <GridContainer {...styles.popoverGridContainer}>
                            <GridItem {...styles.popoverMenuGridItem}>
                                <SideMenu
                                    pageType={constants.pageType.myAccount}
                                    showRootPage
                                    showSignOut
                                    onClick={closePopover}
                                    extendedStyles={styles.sideMenu}
                                    links={menuItems}
                                />
                            </GridItem>
                            <GridItem {...styles.popoverInfoGridItem}>
                                <LoadingOverlay loading={isInfoLoading} {...styles.loadingOverlay}>
                                    {billTo || shipTo ? (
                                        <StyledWrapper {...styles.infoSection}>
                                            <GridContainer {...styles.infoGridContainer}>
                                                {billTo && (
                                                    <GridItem {...styles.infoGridItem}>
                                                        <Typography {...styles.infoSubtitle}>
                                                            {translate("Billing Address")}
                                                        </Typography>
                                                        <StyledWrapper {...styles.addressWrapper}>
                                                            <AddressInfoDisplay
                                                                {...billTo}
                                                                state={billTo.state?.abbreviation}
                                                                country={billTo.country?.name}
                                                                extendedStyles={styles.address}
                                                            />
                                                        </StyledWrapper>
                                                    </GridItem>
                                                )}
                                                {shipTo && (
                                                    <GridItem {...styles.infoGridItem}>
                                                        <Typography {...styles.infoSubtitle}>
                                                            {/* Store Custom Code */}
                                                            {translate("Shipping Address")}
                                                        </Typography>
                                                        <StyledWrapper {...styles.addressWrapper}>
                                                            <AddressInfoDisplay
                                                                {...shipTo}
                                                                state={shipTo.state?.abbreviation}
                                                                country={shipTo.country?.name}
                                                                extendedStyles={styles.address}
                                                            />
                                                            {/* Store Custom Code */}
                                                            <Link
                                                                onClick={handleNavigateToChangeCustomerPage}
                                                                {...styles.addressLink}
                                                            >
                                                                {translate("Change")}
                                                            </Link>
                                                        </StyledWrapper>
                                                    </GridItem>
                                                )}
                                            </GridContainer>
                                        </StyledWrapper>
                                    ) : null}
                                    {enableWarehousePickup && (
                                        <StyledWrapper {...styles.infoSection}>
                                            <GridContainer {...styles.infoGridContainer}>
                                                <GridItem {...styles.infoGridItem}>
                                                    <Typography {...styles.infoSubtitle}>
                                                        {translate("Fulfillment Method")}
                                                    </Typography>
                                                    <RadioGroup
                                                        value={fulfillmentMethod}
                                                        onChangeHandler={handleChangeFulfillmentMethod}
                                                        {...styles.fulfillmentRadioGroup}
                                                    >
                                                        <Radio value={FulfillmentMethod.Ship}>
                                                            {translate("Ship")}
                                                        </Radio>
                                                        <Radio value={FulfillmentMethod.PickUp}>
                                                            {translate("Pick Up")}
                                                        </Radio>
                                                    </RadioGroup>
                                                </GridItem>
                                                <GridItem {...styles.infoGridItem}>
                                                    {fulfillmentMethod === FulfillmentMethod.PickUp && (
                                                        <>
                                                            <Typography {...styles.infoSubtitle}>
                                                                {translate("Pick Up Location")}
                                                            </Typography>
                                                            {pickUpWarehouse ? (
                                                                <StyledWrapper {...styles.addressWrapper}>
                                                                    <Typography {...styles.addressName}>
                                                                        {pickUpWarehouse.description ||
                                                                            pickUpWarehouse.name}
                                                                    </Typography>
                                                                    <AddressInfoDisplay
                                                                        {...pickUpWarehouse}
                                                                        extendedStyles={styles.address}
                                                                    />
                                                                </StyledWrapper>
                                                            ) : null}
                                                            <Link onClick={changeWarehouse} {...styles.addressLink}>
                                                                {translate("Change")}
                                                            </Link>
                                                        </>
                                                    )}
                                                </GridItem>
                                            </GridContainer>
                                        </StyledWrapper>
                                    )}
                                </LoadingOverlay>
                            </GridItem>
                        </GridContainer>
                        {/* Store Custom Code - End */}
                    </Popover>
                    {isSignedIn && isLocationModalOpen && (
                        <Suspense fallback={null}>
                            <FindLocationModal
                                modalIsOpen={isLocationModalOpen}
                                onWarehouseSelected={selectWarehouse}
                                onModalClose={closeLocationModal}
                            />
                        </Suspense>
                    )}
                </>
            )}
            {(!includeAccountMenu || !userName || (userName && currentUserIsGuest)) && (
                /* Store Custom Code - Start */
                <Clickable
                    {...styles.titleClickable}
                    onClick={onSignInHandler}
                    href={!signInUrl ? "/MyAccount/SignIn" : signInUrl}
                    data-test-selector="header_signIn"
                    as="a"
                >
                    {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                    {/* A11Y - span for accessibility */}
                    <Hidden below="lg" as="span">
                        {showLabel && (
                            <Typography {...styles.titleTypography} title={signInStatusText}>
                                {signInStatusText}
                            </Typography>
                        )}
                    </Hidden>
                </Clickable>
                /* Store Custom Code - End */
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(HeaderSignIn))),
    definition: {
        displayName: "Header Sign In",
        icon: "arrow-right-to-bracket",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Icon and Label", // Starter Custom Code
                        value: "both",
                    },
                    // Starter Removed - Show Label
                    {
                        displayName: "Show Icon Only", // Starter Custom Code
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "SignIn Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "User",
                        value: "user", // Starter Custom Code
                    },
                ],
                defaultValue: "user", // Starter Custom Code
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.includeAccountMenu,
                displayName: "Include My Account Menu",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
